/** A failed auth service request does not establish that stored credentials were rejected. */
export class AuthSessionUnavailableError extends Error {
  constructor(cause: unknown) {
    super("La connexion est temporairement indisponible. Réessayez.", { cause });
    this.name = "AuthSessionUnavailableError";
  }
}

export const AUTH_SESSION_CHANGED_EVENT = "teams:auth-session-changed";
export const IMPERSONATION_SESSION_KEY = "teams.impersonation.v1";
export const LEGACY_SESSION_GENERATION_KEY = "teams.legacy.generation";

// Survives Pinia resets until the browser leaves Teams (or local-only sign-out finishes).
let loggingOut = false;
export function isAuthLoggingOut(): boolean {
  return loggingOut;
}
export function beginAuthLogout(): void {
  loggingOut = true;
  notifyAuthSessionChanged();
}
export function finishAuthLogout(): void {
  loggingOut = false;
}

let documentUnloading = false;
if (typeof window !== "undefined") {
  // pagehide only fires when navigation proceeds, unlike a cancellable beforeunload prompt.
  window.addEventListener("pagehide", () => {
    documentUnloading = true;
  });
  window.addEventListener("pageshow", (event) => {
    documentUnloading = false;
    if (event.persisted) finishAuthLogout();
  });
}

export function isAuthDocumentUnloading(): boolean {
  return documentUnloading;
}

/** Abort long-lived transports and let mounted account-specific UI discard its state. */
export function notifyAuthSessionChanged(): void {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(AUTH_SESSION_CHANGED_EVENT));
}
